import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _94c76ce8 = () => interopDefault(import('../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _78744eab = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _82aca272 = () => interopDefault(import('../pages/clearance/index.vue' /* webpackChunkName: "pages/clearance/index" */))
const _ffd73c4a = () => interopDefault(import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _fa518302 = () => interopDefault(import('../pages/delivery/index.vue' /* webpackChunkName: "pages/delivery/index" */))
const _54de15ba = () => interopDefault(import('../pages/denied.vue' /* webpackChunkName: "pages/denied" */))
const _71a60a53 = () => interopDefault(import('../pages/gate.vue' /* webpackChunkName: "pages/gate" */))
const _31576c4d = () => interopDefault(import('../pages/legal-info/index.vue' /* webpackChunkName: "pages/legal-info/index" */))
const _9d6d29de = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _761600dc = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _7b48662a = () => interopDefault(import('../pages/menu/index.vue' /* webpackChunkName: "pages/menu/index" */))
const _789b9a9e = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _698603fa = () => interopDefault(import('../pages/pizza-construct.vue' /* webpackChunkName: "pages/pizza-construct" */))
const _4c24e680 = () => interopDefault(import('../pages/postavshikam.vue' /* webpackChunkName: "pages/postavshikam" */))
const _9c4f71d8 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _45a3ba0c = () => interopDefault(import('../pages/promo/index.vue' /* webpackChunkName: "pages/promo/index" */))
const _56711862 = () => interopDefault(import('../pages/promos/index.vue' /* webpackChunkName: "pages/promos/index" */))
const _fd24ee3a = () => interopDefault(import('../pages/review/index.vue' /* webpackChunkName: "pages/review/index" */))
const _501a438f = () => interopDefault(import('../pages/thankyoupage/index.vue' /* webpackChunkName: "pages/thankyoupage/index" */))
const _70901601 = () => interopDefault(import('../pages/vacancies.vue' /* webpackChunkName: "pages/vacancies" */))
const _7523b986 = () => interopDefault(import('../pages/vk.vue' /* webpackChunkName: "pages/vk" */))
const _67a4e4be = () => interopDefault(import('../pages/app/download.vue' /* webpackChunkName: "pages/app/download" */))
const _ef5d5c44 = () => interopDefault(import('../pages/clearance/login.vue' /* webpackChunkName: "pages/clearance/login" */))
const _492b316e = () => interopDefault(import('../pages/delivery/map.vue' /* webpackChunkName: "pages/delivery/map" */))
const _359579a3 = () => interopDefault(import('../pages/delivery/security.vue' /* webpackChunkName: "pages/delivery/security" */))
const _91a4efc6 = () => interopDefault(import('../pages/legal-info/account-deleting.vue' /* webpackChunkName: "pages/legal-info/account-deleting" */))
const _ce5c95e8 = () => interopDefault(import('../pages/legal-info/privacy-policy-courier.vue' /* webpackChunkName: "pages/legal-info/privacy-policy-courier" */))
const _077917f4 = () => interopDefault(import('../pages/review/thankyou.vue' /* webpackChunkName: "pages/review/thankyou" */))
const _30bc700c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _bdc5957e = () => interopDefault(import('../pages/delivery/points/_slug.vue' /* webpackChunkName: "pages/delivery/points/_slug" */))
const _31e88683 = () => interopDefault(import('../pages/delivery/_region/index.vue' /* webpackChunkName: "pages/delivery/_region/index" */))
const _2fa0cb05 = () => interopDefault(import('../pages/legal-info/_slug.vue' /* webpackChunkName: "pages/legal-info/_slug" */))
const _44eed1c5 = () => interopDefault(import('../pages/menu/_name/index.vue' /* webpackChunkName: "pages/menu/_name/index" */))
const _5628a6f4 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _39fc9be2 = () => interopDefault(import('../pages/promo/_id.vue' /* webpackChunkName: "pages/promo/_id" */))
const _3023c412 = () => interopDefault(import('../pages/promos/_id.vue' /* webpackChunkName: "pages/promos/_id" */))
const _b59c4492 = () => interopDefault(import('../pages/thankyoupage/_id.vue' /* webpackChunkName: "pages/thankyoupage/_id" */))
const _09c04be4 = () => interopDefault(import('../pages/delivery/_region/_category.vue' /* webpackChunkName: "pages/delivery/_region/_category" */))
const _095e381d = () => interopDefault(import('../pages/menu/_name/_single/index.vue' /* webpackChunkName: "pages/menu/_name/_single/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/app",
    component: _94c76ce8,
    pathToRegexpOptions: {"strict":true},
    name: "app"
  }, {
    path: "/cart",
    component: _78744eab,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/clearance",
    component: _82aca272,
    pathToRegexpOptions: {"strict":true},
    name: "clearance"
  }, {
    path: "/contacts",
    component: _ffd73c4a,
    pathToRegexpOptions: {"strict":true},
    name: "contacts"
  }, {
    path: "/delivery",
    component: _fa518302,
    pathToRegexpOptions: {"strict":true},
    name: "delivery"
  }, {
    path: "/denied",
    component: _54de15ba,
    pathToRegexpOptions: {"strict":true},
    name: "denied"
  }, {
    path: "/gate",
    component: _71a60a53,
    pathToRegexpOptions: {"strict":true},
    name: "gate"
  }, {
    path: "/legal-info",
    component: _31576c4d,
    pathToRegexpOptions: {"strict":true},
    name: "legal-info"
  }, {
    path: "/login",
    component: _9d6d29de,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/logout",
    component: _761600dc,
    pathToRegexpOptions: {"strict":true},
    name: "logout"
  }, {
    path: "/menu",
    component: _7b48662a,
    pathToRegexpOptions: {"strict":true},
    name: "menu"
  }, {
    path: "/news",
    component: _789b9a9e,
    pathToRegexpOptions: {"strict":true},
    name: "news"
  }, {
    path: "/pizza-construct",
    component: _698603fa,
    pathToRegexpOptions: {"strict":true},
    name: "pizza-construct"
  }, {
    path: "/postavshikam",
    component: _4c24e680,
    pathToRegexpOptions: {"strict":true},
    name: "postavshikam"
  }, {
    path: "/profile",
    component: _9c4f71d8,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/promo",
    component: _45a3ba0c,
    pathToRegexpOptions: {"strict":true},
    name: "promo"
  }, {
    path: "/promos",
    component: _56711862,
    pathToRegexpOptions: {"strict":true},
    name: "promos"
  }, {
    path: "/review",
    component: _fd24ee3a,
    pathToRegexpOptions: {"strict":true},
    name: "review"
  }, {
    path: "/thankyoupage",
    component: _501a438f,
    pathToRegexpOptions: {"strict":true},
    name: "thankyoupage"
  }, {
    path: "/vacancies",
    component: _70901601,
    pathToRegexpOptions: {"strict":true},
    name: "vacancies"
  }, {
    path: "/vk",
    component: _7523b986,
    pathToRegexpOptions: {"strict":true},
    name: "vk"
  }, {
    path: "/app/download",
    component: _67a4e4be,
    pathToRegexpOptions: {"strict":true},
    name: "app-download"
  }, {
    path: "/clearance/login",
    component: _ef5d5c44,
    pathToRegexpOptions: {"strict":true},
    name: "clearance-login"
  }, {
    path: "/delivery/map",
    component: _492b316e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-map"
  }, {
    path: "/delivery/security",
    component: _359579a3,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-security"
  }, {
    path: "/legal-info/account-deleting",
    component: _91a4efc6,
    pathToRegexpOptions: {"strict":true},
    name: "legal-info-account-deleting"
  }, {
    path: "/legal-info/privacy-policy-courier",
    component: _ce5c95e8,
    pathToRegexpOptions: {"strict":true},
    name: "legal-info-privacy-policy-courier"
  }, {
    path: "/review/thankyou",
    component: _077917f4,
    pathToRegexpOptions: {"strict":true},
    name: "review-thankyou"
  }, {
    path: "/",
    component: _30bc700c,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/delivery/points/:slug?",
    component: _bdc5957e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-points-slug"
  }, {
    path: "/delivery/:region",
    component: _31e88683,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-region"
  }, {
    path: "/legal-info/:slug?",
    component: _2fa0cb05,
    pathToRegexpOptions: {"strict":true},
    name: "legal-info-slug"
  }, {
    path: "/menu/:name",
    component: _44eed1c5,
    pathToRegexpOptions: {"strict":true},
    name: "menu-name"
  }, {
    path: "/news/:id",
    component: _5628a6f4,
    pathToRegexpOptions: {"strict":true},
    name: "news-id"
  }, {
    path: "/promo/:id",
    component: _39fc9be2,
    pathToRegexpOptions: {"strict":true},
    name: "promo-id"
  }, {
    path: "/promos/:id",
    component: _3023c412,
    pathToRegexpOptions: {"strict":true},
    name: "promos-id"
  }, {
    path: "/thankyoupage/:id",
    component: _b59c4492,
    pathToRegexpOptions: {"strict":true},
    name: "thankyoupage-id"
  }, {
    path: "/delivery/:region/:category",
    component: _09c04be4,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-region-category"
  }, {
    path: "/menu/:name/:single",
    component: _095e381d,
    pathToRegexpOptions: {"strict":true},
    name: "menu-name-single"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
